import axios from 'axios'
import axiosConfig from '../../../config/axios.config'
import { checkResponseErrorCodeAndRedirect } from '../../../utils/errorHelper';
const {apiUrl} = axiosConfig;

// -- fetch trial data
export const fetchPatient = async (id, instance, email) => {
  try {
    const data = await axios.get(`${apiUrl}/rt/getRegistry/${id}/${instance}/${email}`) // removed 'axiosConfig.auth' as token is updated on login
    return data.data ? data.data : data;
  } catch(err) {console.error(err, 'Error occurred fetching patient data.')}
}

// -- send update to server
export const updatePatient = (id, instance, email, originalData, updatedData) => new Promise((resolve,reject) => {
  console.log(id, instance, email, originalData, updatedData, "ON PATIENT SAVE")
  let body = {
    custom: updatedData,
    original: originalData
  };

  let url = `${apiUrl}/rt/saveRegistry/${id}/${instance}/${email}`;

  axios.post(url, body)
    .then(data => resolve(data))
    .catch(err => {
      checkResponseErrorCodeAndRedirect(err)
      reject(err)
    });
})
